export default "__VITE_ASSET__B7ml3rMF__"